import React, { MouseEvent } from 'react';
import { useThemeContext } from 'contexts';
import { ThemeNames } from 'types/themes';

interface Props {
  className?: string;
  onClick?: (event: MouseEvent<Element>) => void;
}

const ClockIcon = ({ className, onClick }: Props) => {
  const { themeName } = useThemeContext();
  const isExpTheme = themeName && themeName !== ThemeNames.ZOOCASA;
  
  return ( !isExpTheme ?
    <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36" className={className} onClick={onClick}>
      <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
        <g fill="#000" fillRule="nonzero">
          <path d="M17.92 0C8.016 0 0 8.015 0 17.92c0 9.904 8.015 17.92 17.92 17.92 9.904 0 17.92-8.015 17.92-17.92C35.84 8.016 27.825 0 17.92 0zm11.636 27.576l-.945-.944a1.4 1.4 0 10-1.98 1.98l.945.944a14.976 14.976 0 01-8.256 3.42V31.64a1.4 1.4 0 10-2.8 0v1.336a14.976 14.976 0 01-8.256-3.42l.945-.945a1.4 1.4 0 10-1.98-1.98l-.945.945a14.976 14.976 0 01-3.42-8.256H4.2a1.4 1.4 0 100-2.8H2.864a14.976 14.976 0 013.42-8.256l.945.945a1.4 1.4 0 101.98-1.98l-.945-.945a14.977 14.977 0 018.256-3.42V4.2a1.4 1.4 0 102.8 0V2.864a14.976 14.976 0 018.256 3.42l-.944.945a1.4 1.4 0 101.98 1.98l.944-.945a14.976 14.976 0 013.42 8.256H31.64a1.4 1.4 0 100 2.8h1.336a14.976 14.976 0 01-3.42 8.256zM20.89 18.91a1.4 1.4 0 11-1.98 1.98l-1.98-1.98a1.4 1.4 0 01-.41-.99V12.6a1.4 1.4 0 112.8 0v4.74l1.57 1.57z"></path>
        </g>
      </g>
    </svg>
    :
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path fillRule="evenodd" clipRule="evenodd" d="M10 18.333c4.602 0 8.333-3.731 8.333-8.333S14.602 1.667 10 1.667 1.667 5.398 1.667 10 5.398 18.333 10 18.333zm0-1.666a6.667 6.667 0 100-13.334 6.667 6.667 0 000 13.334z" fill="#0C0F24"/>
      <path d="M10.833 6.667a.833.833 0 10-1.666 0v3.585c0 .221.088.433.244.589l2.5 2.5a.833.833 0 101.178-1.178l-2.256-2.257V6.667z" fill="#0C0F24"/>
    </svg>

  );
};

export default ClockIcon;
